<template>
  <section class="article-video">
    <ShapeBlobPaleOrange class="article-video__blob-left" />
    <ShapeDarkGreen class="article-video__blob-right" />
    <no-ssr>
      <div class="video-wrapper">
        <iframe
            :data-src="videoSrc"
            src=""
            :title="`video_${sourceId}`"
            frameborder="0"
            allowfullscreen
            class="lazyload"
        />
      </div>
    </no-ssr>
  </section>
</template>

<script>
import ShapeBlobPaleOrange from '~/assets/images/events-community/shape-blob-pale-orange.svg?inline';
import ShapeDarkGreen from '~/assets/images/events-community/shape-dark-green.svg?inline';

export default {
  components: {
    ShapeBlobPaleOrange,
    ShapeDarkGreen,
  },
  props: {
    sourceId: {
      type: String,
      required: true,
    },
  },
  computed: {
    videoSrc() {
      return `//youtube.com/embed/${this.sourceId}?showinfo=0&autoplay=0&rel=0`;
    },
  },
  mounted() {
    const vidDefer = document.getElementsByTagName('iframe');
    for (let i=0; i<vidDefer.length; i++) {
      if (vidDefer[i].getAttribute('data-src')) {
        vidDefer[i].setAttribute('src', vidDefer[i].getAttribute('data-src'));
      }
    }
  },
};
</script>

<style lang="scss">
@import '~/assets/scss/atomic/components/_article-video.scss';
</style>
